var xmljson = require('./xmljson');
var Codec = require('io/codec');

var serialiser = {
    read : function(input) {
        return xmljson.xml2json(Codec.readString(input));
    },
    write : function(output, schema) {
        if (schema && (schema.field || schema.message)) {
            Codec.writeString(output, xmljson.json2xml(schema));
        }
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/schema/serialiser.js
// module id = 1024
// module chunks = 1